/**
 * Hook para tratar mensagens FCM em foreground (app aberto).
 * Quando o app está aberto, o service worker não exibe a notificação;
 * este hook recebe a mensagem e exibe um toast.
 */

import { useEffect } from 'react'
import { getApp, getApps, initializeApp } from 'firebase/app'
import { getMessaging, onMessage } from 'firebase/messaging'
import {
  firebaseConfig,
  isFirebaseConfigured,
} from '@/shared/config/firebase'
import type { MessagePayload } from 'firebase/messaging'

export function useForegroundMessages(onMessageReceived: (payload: MessagePayload) => void) {
  useEffect(() => {
    if (!isFirebaseConfigured()) return

    try {
      const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig)
      const messaging = getMessaging(app)
      const unsubscribe = onMessage(messaging, (payload) => {
        onMessageReceived(payload)
      })
      return () => {
        unsubscribe()
      }
    } catch {
      return undefined
    }
  }, [onMessageReceived])
}
